import { AuthService } from './../../../shared/services/auth.service';
import { Club } from './../club.model';
import { BaseFormComponent } from 'src/app/shared/components/base-form-component/base-form-component';
import { Component, Injector } from '@angular/core';
import { Validators } from '@angular/forms';
import { REGEX } from 'src/app/app.validators';
import { ClubsService } from '../clubs.service';

declare var $:any;

@Component({
    selector: 'ng-clubs',
    templateUrl: 'clubs-form.component.html'
})

export class ClubsFormComponent extends BaseFormComponent<Club> {

    public iptColor:any;

    constructor(public injector:Injector,public clubsServ:ClubsService) {
        super(injector,'club','/admin/clubs',Club.fromJsonToObject,clubsServ);
    }

    protected buildForm(): void {

        this.objectForm=this.formBuilder.group({
            name:this.formBuilder.control(null,[Validators.required]),

            email:this.formBuilder.control(null,[Validators.required,Validators.pattern(REGEX.email)]),

            phone:this.formBuilder.control(null,[
                Validators.required,
                Validators.minLength(9),
                Validators.maxLength(14),
                Validators.pattern(REGEX.numberPattern)
            ]),
            address:this.formBuilder.control(null,[Validators.required]),

            nuit:this.formBuilder.control(null,[
                Validators.required,
                Validators.minLength(9),
                Validators.maxLength(9),
                Validators.pattern(REGEX.numberPatternNoComma)
            ]),

            responsible_name:this.formBuilder.control(null,[Validators.required]),

            responsible_email:this.formBuilder.control(null,[Validators.pattern(REGEX.email)]),

            responsible_phone:this.formBuilder.control(null,[
                Validators.minLength(9),
                Validators.maxLength(14),
                Validators.pattern(REGEX.numberPattern)
            ]),

            color:this.formBuilder.control(null,[Validators.required]),

            cities_id:this.formBuilder.control(null,[Validators.required]),

            users_id:this.formBuilder.control(this.auth.user.id),

            id:this.formBuilder.control(null),
      })

    }

    protected initChildProprieties(): void {}
    protected initChildMethods(): void {
        $('.my-colorpicker1').colorpicker()
    }
}
